export const jitSetupViewByOptions = [
  { label: 'For Data', value: 'data' },
  { label: 'For Cloud', value: 'cloud' },
];
